import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const tag = {
  fetchTag: lazyModuleMethod(() => import('./fetchTag'), 'default'),
  fetchTags: lazyModuleMethod(() => import('./fetchTags'), 'default'),
  editTag: lazyModuleMethod(() => import('./editTag'), 'default'),
  addTag: lazyModuleMethod(() => import('./addTag'), 'default'),
  deleteTag: lazyModuleMethod(() => import('./deleteTag'), 'default'),
  fetchDeletedTags: lazyModuleMethod(
    () => import('./fetchDeletedTags'),
    'default'
  ),
  restoreTag: lazyModuleMethod(() => import('./restoreTag'), 'default'),
}
